// import {combineReducers} from 'redux';
import {Reducer} from 'redux';
//
import {AppState} from '../../types/state.types';
//
// const CombinedReducers = combineReducers<AppState>({
//     // example: exampleReducer
// });

// stub out reducer and avoid console.error
const CombinedReducers: Reducer = (state: AppState) => state;

export default CombinedReducers;
